import { Observable } from 'rxjs'
import { CampaignCode } from '../models/CampaignCode'
import { CallLogLookUp } from '../models/call-log-lookup'
import { DispositionLookUP } from '../models/disposition-lookup'
import { Emailorder } from '../models/EmailOrder'
import { ValidatedSelectOptionModel } from '../../validations/validated-dropdown.component'
export abstract class callStartGateway {
    private _pharmacyLocatorURL: string = ''

    abstract verifyVdn(vdn: number): Observable<CampaignCode>
    abstract setCallLogLookUpModel(value: CallLogLookUp)
    abstract getCallLogLookUpModel(): CallLogLookUp
    abstract getStateAbbrByZipCode(zipcode: string): Observable<ValidatedSelectOptionModel[]>

    abstract getStateByZipCode(zipcode: string): Observable<string>

    abstract getDispositionByPlanYear(planYear: string): Observable<DispositionLookUP[]>
    abstract saveCallLogLookUp(callLogLookUp: CallLogLookUp): Observable<number>
    abstract updatedispositionId(dispositionId: number, calllogId: number): Observable<number>
    abstract getTimer(): number
    abstract setTimer(time: number)
    abstract getEmailConfirm(): string
    abstract setEmailConfirm(emailConfirm: string)
    abstract saveEmailOrder(emailOrder: Emailorder): Observable<any>
    abstract setEmailOrder(value: Emailorder)
    abstract getEmailOrder(): Emailorder
    abstract downloadPDF(campaignCode: CampaignCode): Observable<any>
    abstract getRegionIDbyZipCode(value: string): Observable<number>

    get pharmacyLocatorURL() {
        return this._pharmacyLocatorURL
    }
    set pharmacyLocatorURL(value: string) {
        this._pharmacyLocatorURL = value
    }

    abstract loadRouting()
    abstract getPreviousUrl()
    abstract getCallStartTime(): Observable<string>
}
